import { Context } from 'Context/Context';
import React, { useState } from 'react'
import { useContext } from 'react';
import TestModal from 'Modals/TestModal';
import useIsMobile from 'Hooks/useIsMobile';
import { useNavigate } from 'react-router-dom';
import CaseCard, { StatusPill } from './CaseCard';
import { openCasePage, fmtDate } from './CaseStage';
import { CardStack, CardNotice, CaseBtn, EmptyState } from './CaseListUI';

function ClosedCases({attorney, cases, setUpdateComp, reqRevCountArr, emptyText}) {
    const [showEachCase, setShowEachCase] = useState(false);
        const {userDetails} = useContext(Context);
            const isMobile = useIsMobile();
    const navigate = useNavigate();
    const usePage = !attorney;   // full case page; assistants keep the popup
        
    
    const userInfo = attorney ? attorney.userId : userDetails;

    const [singleCase, setSingleCase] = useState(null);

    const submit = (key) => {
        //navigate("/profCaseDetails/"+cases?.[key]?._id);
        setShowEachCase(true);
        setSingleCase(cases?.[key]);
    }
    const deletionDate = (updatedAt) => {
        const updatedDate = new Date(updatedAt);
        updatedDate.setDate(updatedDate.getDate() + 7);
        const result = updatedDate.toDateString();
        return result;
    }
  if (showEachCase && singleCase) {
    return <TestModal attorney={attorney} reqRevCountArr={reqRevCountArr} setUpdateComp={setUpdateComp} onClose={()=>{setShowEachCase(false)}} uploadNew={showEachCase} caseData={singleCase} setSingleCase={setSingleCase} />
  }
  if (!cases?.length) {
    return <EmptyState title={emptyText?.title || 'No closed cases yet'} body={emptyText?.body || 'Cases will appear here as they move into this stage. Try changing your filters.'} />
  }
  return (
    <CardStack>
        {cases.map((detail, key) => {
            const team = detail?.assistantId?.length ? detail.assistantId[0] : null;
            return (
                <CaseCard
                    key={detail?._id || key}
                    detail={detail.caseDetails}
                    userInfo={userInfo}
                    reqRevCountArr={reqRevCountArr}
                    showNames={true}
                    hideStats={true}
                    dimmed={!!(detail.isClosed || detail.is_deleted)}
                    onOpen={isMobile ? undefined : () => (usePage ? openCasePage(navigate, detail) : submit(key))}
                    headerPill={usePage ? <StatusPill tone="navy">Closed{fmtDate(detail.updated_at) ? ' · ' + fmtDate(detail.updated_at) : ''}</StatusPill> : undefined}
                    notices={<CardNotice tone="danger">This case and all its information will be deleted automatically on {deletionDate(detail?.updated_at)}.</CardNotice>}
                    footerNote={team ? <>Closed by team <b className="font-semibold text-navy">{team.firstName} {team.lastName}</b></> : null}
                    actions={<CaseBtn onClick={() => (usePage ? openCasePage(navigate, detail) : submit(key))} full={isMobile} style={isMobile ? { height: '46px', fontSize: '14px' } : undefined}>{usePage ? 'Open case →' : 'Complete case details →'}</CaseBtn>}
                />
            )
        })}
    </CardStack>
  )
}

export default ClosedCases;
